import React from 'react'
import { Box, Skeleton } from '@chakra-ui/react'
import { SkeletonText } from '@/components/ui/skeleton'

function SkeletonCard() {
  return (
    <Box
      maxW={{ base: 'sm', lg: 'xl' }}
      overflow='hidden'
      p={2}
      bg={'#fbfbfb'}
      borderRadius='2xl'
    >
      <Skeleton
        rounded={12}
        maxH={{ base: '260px', lg: '290px' }}
        w={'full'}
        aspectRatio='1 / 1'
      />
      <Box>
        <SkeletonText mt='3' noOfLines={1} gap='1' />
        <SkeletonText mt='3' noOfLines={1} gap='1' />
      </Box>
      <Skeleton mt={7} rounded={12} h='40px' w={'full'} />
    </Box>
  )
}

export default SkeletonCard
